export default "__VITE_ASSET__CTFa4pW6__"